
import { defineComponent } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Checkbox from 'primevue/checkbox'
import schedulerTimingOutputOutputTabDescriptor from '../SchedulerTimingOutputOutputTabDescriptor.json'

export default defineComponent({
    name: 'scheduler-file-accordion',
    components: { Accordion, AccordionTab, Checkbox },
    props: { propDocument: { type: Object }, functionalities: { type: Array }, datasets: { type: Array }, jobInfo: { type: Object } },
    data() {
        return {
            schedulerTimingOutputOutputTabDescriptor,
            document: null as any,
            fileNameDirty: false
        }
    },
    computed: {
        fileNameHelp(): string {
            return (this.document.fileName?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.file.nameMaxLength
        },
        destinationFolderHelp(): string {
            return (this.document.destinationfolder?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.file.destinationFolderMaxLength
        },
        zipFileNameHelp(): string {
            return (this.document.zipFileName?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.file.zipFileNameMaxLength
        }
    },
    watch: {
        propDocument() {
            this.loadDocument()
        }
    },
    created() {
        this.loadDocument()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument
            this.document.invalid.invalidFile = false
            this.validateDocument()
        },
        setFileNameValidation() {
            this.fileNameDirty = true
            this.validateDocument()
        },
        validateDocument() {
            this.document.invalid.invalidFile = !this.document.fileName || this.document.fileName.length === 0
        }
    }
})
